
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate subscription
    setIsSubscribed(true);
    setEmail('');
    setTimeout(() => setIsSubscribed(false), 5000);
  };

  return (
    <footer className="bg-stone-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <h4 className="font-semibold text-stone-900 mb-4">NUESTRA EMPRESA</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-stone-600 hover:text-stone-900 text-sm cursor-pointer transition-colors">Sobre nosotros</a></li>
              <li><a href="#" className="text-stone-600 hover:text-stone-900 text-sm cursor-pointer transition-colors">Aviso legal</a></li>
              <li><a href="#" className="text-stone-600 hover:text-stone-900 text-sm cursor-pointer transition-colors">Política de Privacidad</a></li>
              <li><a href="#" className="text-stone-600 hover:text-stone-900 text-sm cursor-pointer transition-colors">Política de Cookies</a></li>
              <li><a href="#" className="text-stone-600 hover:text-stone-900 text-sm cursor-pointer transition-colors">Envío, cambios y devoluciones</a></li>
              <li><a href="#contacto" className="text-stone-600 hover:text-stone-900 text-sm cursor-pointer transition-colors">Contacto</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-stone-900 mb-4">INFORMACIÓN</h4>
            <div className="text-stone-600 text-sm space-y-2">
              <p>Calle Hermanos Villalonga 5</p>
              <p>Bajo Derecha, 46020</p>
              <p>Valencia, España</p>
              <p className="pt-2">
                <a href="mailto:cosmeticaproshop@gmail.com" className="hover:text-stone-900 transition-colors">
                  cosmeticaproshop@gmail.com
                </a>
              </p>
            </div>
          </div>

          {/* Newsletter */}
          <div className="md:col-span-2">
            <h4 className="font-semibold text-stone-900 mb-4">
              Suscríbete y recibe las últimas novedades y promociones
            </h4>
            <form id="newsletter-form" data-readdy-form onSubmit={handleNewsletterSubmit} className="flex gap-2 mb-4">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Suscríbete a nuestra lista de correo"
                className="flex-1 px-4 py-3 border border-stone-300 rounded-lg focus:ring-2 focus:ring-stone-500 focus:border-transparent outline-none text-sm"
                required
              />
              <button
                type="submit"
                className="px-6 py-3 bg-stone-900 text-white font-medium hover:bg-stone-800 transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                Suscribir
              </button>
            </form>
            {isSubscribed && (
              <p className="text-green-600 text-sm">¡Gracias por suscribirte!</p>
            )}

            {/* Social Icons */}
            <div className="flex gap-4 mt-6">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-stone-200 hover:bg-stone-900 hover:text-white rounded-full transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-stone-200 hover:bg-stone-900 hover:text-white rounded-full transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-stone-200 hover:bg-stone-900 hover:text-white rounded-full transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="flex flex-wrap justify-center gap-4 mt-12 pt-8 border-t border-stone-200">
          <div className="w-12 h-8 flex items-center justify-center bg-white rounded border border-stone-200">
            <i className="ri-visa-line text-2xl text-stone-600"></i>
          </div>
          <div className="w-12 h-8 flex items-center justify-center bg-white rounded border border-stone-200">
            <i className="ri-mastercard-line text-2xl text-stone-600"></i>
          </div>
          <div className="w-12 h-8 flex items-center justify-center bg-white rounded border border-stone-200">
            <i className="ri-paypal-line text-2xl text-stone-600"></i>
          </div>
          <div className="w-12 h-8 flex items-center justify-center bg-white rounded border border-stone-200">
            <i className="ri-bank-card-line text-2xl text-stone-600"></i>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center mt-8 pt-8 border-t border-stone-200">
          <p className="text-stone-500 text-sm">
            © 2025 Cosmetica Pro Shop Valencia. Todos los derechos reservados.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="nofollow noopener noreferrer" 
            className="text-stone-400 hover:text-stone-600 text-xs mt-2 inline-block transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
